/** @jsx jsx */
import React, { type ReactNode } from 'react';

import { css, jsx } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

type Props = {
	name: string;
	children: ReactNode;
	mode?: 'list' | 'single';
};

/**
 * used only on staging with jira_highlight_ufo_segments fg to see ufo segments
 */
export const JiraUfoSegmentWrapperWithHighlight = ({ children, name }: Props) => {
	return (
		<Box xcss={borderStyles}>
			<span css={textStyles}>{name}</span>
			{children}
		</Box>
	);
};

/**
 * used only on staging with jira_highlight_ufo_segments fg to see ufo segments
 */
export const JiraUfoSegmentWrapperWithHighlightBlack = ({ children, name }: Props) => {
	return (
		<Box xcss={borderStylesBlack}>
			<span css={textStylesBlack}>{name}</span>
			{children}
		</Box>
	);
};

const textStyles = css({
	position: 'relative',
	color: token('color.text.accent.blue'),
	display: 'flex',
	justifyContent: 'center',
});

const borderStyles = xcss({
	border: '2px solid blue',
	borderRadius: 'radius.small',

	padding: 'space.100',
});

const textStylesBlack = css({
	position: 'relative',
	color: token('color.text'),
	display: 'flex',
	justifyContent: 'center',
});

const borderStylesBlack = xcss({
	border: '2px solid black',
	borderRadius: 'radius.small',
	padding: 'space.100',
});
